import {useContext} from 'react'
import { Link } from 'react-router-dom'
import SearchHeader from '../SearchHeader/SearchHeader'
import './Header.css'
import LanguageSelector from '../LanguageSelector/LanguageSelector'
import { LanguageContext } from '../../context';
import Navigation from '../Navigation/Navigation'
import Translate, { useTranslate } from '../Translate/Translate'

const Header = () => {

    const { language } = useContext(LanguageContext);
    var config = require('../../config.json');

    const goTo=(divClass)=>{

        var divFocus= document.getElementsByClassName(divClass);
        //if(divFocus.att)
        // var $elem = $('#' + divId).first();
    
        // while ($elem.is(":visible") == false) {
        //     $elem = $elem.next();
        //     if ($elem.length == 0) break;
        // }
    
        // if ($elem.is(":visible").length > 0) {
        //     $elem = $elem.first();
        // }
    
        // $elem.attr("tabindex", "-1");
    
        // $('html, body').animate({
        //     scrollTop: $elem.offset().top - 170
        // }, 800);
    
        // $elem.focus();
        
    }

   

  return (
    <>
    {/* <ul id="skip">
    <li><a title={useTranslate("GoToContent")} href="javascript:void(0);" onKeyUp={goTo('mainContent')} onClick={goTo('mainContent')}><Translate>GoToContent</Translate></a></li>
</ul> */}
        <div className='header-top'>
            <nav className='right-section' aria-label="קישורים">
                <Navigation/>
            <Link  to={{pathname:`/${language}`}}>
                <div className='header-title'>TLV OpenData</div>
                </Link>
            </nav>
           
            <nav className='logo-section' aria-label="לאתר העירייה">
                 <div className="logoBackGround"></div>
                <a  className='logo' href={`${config.TlvWeb}/${language=="en"?language:""}`} target='_blank'>
                    <div className='logo-header'></div>
                    <div className="sr-only">לאתר עיריית תל אביב</div>
                </a>
            </nav>
            <nav className='left-section' aria-label="תפריט חיפוש ושפות">
                <div className="search" aria-label="חיפוש"><SearchHeader/></div>          
                <div className="language"><LanguageSelector/></div>
                
            </nav>
        </div>
        <div className='border'></div>
        <h1 className='sr-only'><Translate>WelcomeOD</Translate></h1>
    </>
  )
}

export default Header